export default __webpack_public_path__ + "7d4e3dc7d11a61d2823e4c630207bb52.png";